
import React from 'react';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import MasterICCardSettingForm from 'components/organismos/master/MasterICCardSettingForm';

const MasterICCardSettingPage = () => (
    <SidebarTemplate>
        <MasterICCardSettingForm/>
    </SidebarTemplate>
);

export default MasterICCardSettingPage;
